import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { Modalable } from "@app/Modalable"
import { BtnExtComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-terms-sms",
	imports: [COMMON_IMPORTS, BtnExtComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="terms-sms">
			<p><strong>מי קליניק - הסכם שירות מסרונים</strong></p>
			<p>
				האמור בהסכם זה, בכל לשון, חל במידה שווה על כל מיגדר ועל כל יישות משפטית
				אחרת.
			</p>
			<p>
				מוסכם על שני הצדדים שהשימוש בשירות, מהווה אישור כי ההסכם נקרא והובן ע"י
				המשתמש, ושהוא הסכים לקבל עליו את תנאיו כתנאי לשימוש בשירות, בכפוף לשימוש
				במערכת מי קליניק על הסכמיה ותנאיה והוא יהיה מנוע מלהעלות טענות כלשהן
				בעניינים אילו כלפי מי קליניק.
			</p>
			<p>
				מוסכם שמי-קליניק רשאית להחליף בכל עת את הספק לפי שיקול דעתה
				הבלעדי.&nbsp;
			</p>
			<p><strong>השירות</strong></p>
			<p>
				מי-קליניק, מציעה למשתמשים רשומים, שירות שליחת מסרוני טקסט (להלן
				ה"שירות") מתוך המערכת.
			</p>
			<p>
				השירות, ניתן למשתמשים רשומים כתוספת והוא נשען על ספק חיצוני (להן ה"ספק")
				וחברות הסלולר, מותנה בדרישות החוק, חשוף לסיכוני אבטחה ולפרטיות וכרוך
				באחריות שעלולה להיות כרוכה בסיכון כספי.&nbsp;
			</p>
			<p>לאור זאת, נא לקרוא בתשומת לב את תנאי ההסכם.&nbsp;</p>
			<p><strong>תקופת השימוש</strong></p>
			<p>
				המשתמש ו/או מי-קליניק רשאים להפסיק בכל עת את השימוש בשירות, ללא עילה
				לפיצוי.&nbsp;
			</p>
			<p>
				המשתמש ער לעובדה שהספק או החברה הסלולרית עלולים להפסיק או להגביל בכל עת
				את השירות.
			</p>
			<p>
				המשתמש יודע ומסכים שתיתכן השעיית השימוש בשירות, במידה ועולה חשד לשימוש
				במערכת שלא על פי הוראות ההסכם או להעברת מסרים הנוגדים את הוראות החוק, עד
				לבירור והסדרת הנושא.&nbsp;
			</p>
			<p>
				מוסכם, הפסקת השימוש בשירות, אינה מבטלת כלשעצמה את המשך השימוש במערכת
				מי-קליניק.&nbsp;
			</p>
			<p><strong>התחייבות שימוש</strong></p>
			<ol>
				<li>השימוש בשירות יהיה למטרות חוקיות ובאופן חוקי בלבד.&nbsp;</li>
				<li>המשתמש אחראי לכל שימוש בשירות שנעשה דרכו גם עי אדם אחר.&nbsp;</li>
				<li>
					המשתמש מתחייב לשלוח הודעות אך ורק ללקוחותיו, לאחר קבלת הסכמתם, או למי
					שנתן הסכמה מפורשת ובכתב לקבלת מסרונים ולא לשלוח הודעות ששליחתן נאסרה
					על פי חוק, תוך עמידה בתיקון מס' 40 לחוק התקשורת (חוק הספאם) ועל פי
					הוראות כל דין.
				</li>
			</ol>
			<p><strong>כללי תוכן&nbsp;</strong></p>
			<p>
				ידוע ומוסכם שתותר שליחת רק מסרונים שאושרו ע"י מי-קליניק. <br />ידוע
				למשתמש שכל מסרון ישא את פרטי הזהוי של המשתמש. <br />ידוע ומוסכם שהמשתמש
				יהיה האחראי הבלעדי למהות תוכן וסגנון המסרונים.המשתמש מתחייב לא להשתמש
				במערכת להעברת מסרונים הסותרים את כללי התוכן הבאים:
			</p>
			<ol>
				<li>
					כל חומר הפוגע או מפר ו/או עלול להפר זכויות קניניות של אחרים ; לרבות
					זכויות יוצרים או סימני מסחר ו/או סודות מסחריים. כל חומר העלול להוות
					עוולה מסחרית ו/או לפגוע בזכות לשם טוב, ו/או בזכויות חוזיות ו/או בחובות
					אמון לאחרים.
				</li>
				<li>
					כל חומר המהווה לשון הרע על אדם, או הפוגע בפרטיותו או העלול להוות בסיס
					לתביעה אזרחית. כל חומר בעל אופי פורנוגרפי, ארוטי, מיני, טורדני, מעליב,
					עוין, מאיים, גס, גזעני או פוגע ברגשות הציבור.
				</li>
				<li>
					כל תוכנת מחשב, קוד מחשב או יישום הכוללים נגיף-מחשב ("וירוס"), לרבות
					תוכנות-עוינות הידועות כסוס-טרויאני, תולעים (Worms), ואנדלים (Vandals),
					יישומים מזיקיםMalicious) Applications ) וכיו"ב.
				</li>
				<li>
					כל חומר בלתי-חוקי, או חומר המעודד, תומך, מסייע, מספק הוראות לביצוע או
					מנחה בביצוע מעשה המהווה עבירה פלילית לפי דיני מדינת ישראל. כל חומר
					שפרסומו נאסר לפי הוראות כל דין.
				</li>
				<li>
					כל חומר הפוגע ו/או עלול לפגוע במוניטין ו/או בשם הטוב של מי קליניק ו/או
					הספק ו/או כל חומר הקשור לשירותי המפעילים הסלולרים.
				</li>
				<li>
					כל חומר העלול להטעות צרכן, כמשמעות הדברים בחוק הגנת הצרכן, תשמ"א-
					1981.
				</li>
				<li>
					כל תוכן שיש בו שידור של "דואר זבל", "SPAM"; או משלוח המוני של הודעות
					דואר אלקטרוני או מסרונים שלא על-פי בקשת המנוי.
				</li>
				<li>
					כל קישור (LINK) או הפניה לחומר שפרסומו נאסר לפי כללי התוכן שלעיל.
				</li>
			</ol>
			<p><strong>סודיות&nbsp;</strong></p>
			<ol>
				<li>
					אבטחת מידע מוחלטת אינה ברת השגה. בהתאם, שימוש במערכת מסרונים כרוך
					בסיכוני אבטחת מידע, סודיות ופרטיות, הן ביחס לתוכן והן ביחס לפרטים
					נוספים ביחס למסרון המסרון, דוגמת חשיפת הקשר בין המטפל למטופל (להלן
					"המידע").&nbsp;
				</li>
				<li>
					לאור זאת, יש לקבל הסכמת המטופל לקבלת מסרונים, ויש לנקוט זהירות רבה
					ביחס לתכנים המועברים דרכם.&nbsp;
				</li>
				<li>
					ספק השירות מצהיר שהוא בעל תו תקן ISO 27001 של אבטחת מידע, כי הוא מקפיד
					על נהליו וכן שהמערכת עוברת מבחני חדירות ואבטחת מידע תקופתיים מחמירים
					ע"י גורמים חיצוניים מוסמכים.&nbsp;
				</li>
				<li>
					הספק ידווח בהקדם האפשרי למי קליניק במקרה של אירוע אבטחה או אירוע חריג
					או כל ענין העלול להשפיע על שמירת המידע. בכל חשד לתקלה או ליקוי הנוגע
					למשתמש, יפעלו הספק ומי קליניק לתיקון מוקדם ככל האפשר, וידווחו למשתמש
					על התקלה, השלכותיה והפעולות לתיקונה.&nbsp;
				</li>
				<li>
					הספק יגביל את הגישה למידע רק למי שגישתו למערכת הכרחית לשירות ויפקח
					עליו. הספק מתחייב לא לעשות כל שימוש ברשימות התפוצה של מקבלי המסרונים
					או בתוכנן ולא להעבירן או להעניק גישה לצד ג' כלשהו, שלא למטרת השירות
					נשוא ההסכם או בכפוף לצו רשות מוסמכת.&nbsp;
				</li>
				<li>
					הספק ישמור במאגריו את 3 התווים הראשונים מתוכן של כל מסרון, למשך 7 שנים
					לפחות. לאחר תקופה זו, המשתמש יכול לבקש מחיקת מידע אצל הספק במסגרת
					החוק. במקרים מיוחדים יתכן ויידרש תשלום.&nbsp;
				</li>
				<li>
					הספק יחזיק במשך כל תקופת הסכם זה ביטוח אחריות מקצועית בחברת ביטוח
					מורשית.
				</li>
				<li>
					תביעה הנוגעת לפגיעה בסודיות, אבטחת מידע או פרטיות תוגש תוך שנה מהאירוע
					או מועד גילויו.&nbsp;
				</li>
				<li>
					פירוט נוסף המהווה חלק מההסכם ניתן למצוא במסמך מדיניות פרטיות, סודיות
					ואבטחת מידע במערכת המסרונים
				</li>
			</ol>
			<p><br /><br /></p>
			<p><strong>אחריות</strong></p>
			<ol>
				<li>
					המשתמש יהיה האחראי הבלעדי לכל אובדן, פגיעה, נזק או הפסד שיגרם למי
					קליניק ו/או לספק ו/או למפעיל הסלולרי ו/או למנוי ו/או לצד ג' עקב מעשה
					ו/או מחדל בקשר עם השירות, ולרבות בקשר עם המידע המסופק בשירות ו/או עקב
					פעולה כלשהיא בניגוד לאיזו מהוראות הדין ו/או הוראות הסכם זה. למען הסר
					ספק מובהר כי המשתמש יהיה אחראי לנכונות המידע, מהימנותו ואמינותו. מובהר
					ללקוח שהמפעיל הסלולרי אינו נושא באחריות כלשהי כלפי המשתמש ו/או המנוי
					ו/או צד ג' כלשהו הקשורים בשירותים נשוא הסכם זה.
				</li>
				<li>
					המשתמש מתחייב לשפות /או לפצות את מי-קליניק ו/או הספק ו/או למפעיל
					הסלולרי ו/או כל גורם, בגין כל הוצאה שמי מהם ייאלץ להוציא ו/או בגין כל
					נזק שיגרם למי מהן ו/או הפסד לרבות נזק מיוחד, עקיף, תוצאתי או מסתבר
					הנובעים מעניינים הקשורים למשתמש ו/או לפעילותו לרבות עקב הפרת הוראות
					הסכם זה, לרבות עקב משלוח הודעות הסותרות את כללי התוכן ו/או עקב הפרת
					הוראות החוק ו/או בגין כל הוצאה שתידרש מי-קליניק על ידי ספק השירות ו/או
					על ידי המפעיל הסלולרי אשר עניינה קשור למשתמש ו/או בגין דרישה או תביעה
					של צד ג' הקשורה עם המשתמש, או עם פעילותו. השיפוי והפיצוי יכללו כל
					הוצאה לרבות הוצאות שכ"ט עו"ד, הוצאות משפט, קנסות ועוד. ההתחייבות
					לשיפוי ו/או לפיצוי תישאר בתוקף גם לאחר סיומו של ההסכם, גם אם ההוצאה
					נדרשה ו/או הנזק נוצר ו/או נתגלה אחרי סיום ההסכם, ובלבד שעניינו נוגע
					למשתמש ו/או לפעילות המשתמש בתקופת ההסכם.
				</li>
				<li>
					המשתמש מצהיר שהוא מודע למיגבלות שליחת מסרונים ברשת, כולל בעיות אבטחת
					מידע, והוא משחרר את מי קליניק ו/או ספק השירות ו/או חברות התקשורת מכל
					אחריות עקב תקלה מכל גורם שהוא ומכל מקור שהוא.&nbsp;
				</li>
				<li>
					המשתמש מצהיר שהוא מודע שאין לקחת את קבלת המסרונים ע"י הנמען כמובן
					מאליו, ובמידת הצורך אחריות המשתמש לוודא שאכן הגיעו, נקראו והובנו במועד
					הנדרש.&nbsp;
				</li>
				<li>
					בכל מקרה מי קליניק ו/או ספק השירות ו/או מנהליהם לא ישאו באחריות ישירה
					או עקיפה להגעת ההודעות ליעדם, או לכל הפסד ו/או הוצאה ו/או נזק שיגרמו
					למשתמש או למי מנמעניו, שייגרמו כתווצאה משימוש או כשל או שיבוש כלשהו
					בשליחת המסרונים, מכל עילה שהיא.&nbsp;
				</li>
			</ol>
			<p><strong>הצהרת ספק השירות:</strong></p>
			<ol>
				<li>
					ספק השירות מצהיר כי ישתמש בפרטים שנמסרו על ידי המשתמש לצורך מתן שירות,
					תמיכה, מעקב אחרי התחשבנות כספית, יצירת קשר עם מי-קליניק באמצעות דואר
					אלקטרוני , הודעת טקסט , טלפון ובכל דרך אחרת אשר ימצא לנכון.
				</li>
				<li>
					לא ייעשה שימוש בחשבונות המשתמשים ולא ייעשו שינויים ללא הודעה מראש
					ללקוח.
				</li>
				<li>
					הספק ינקוט בכל האמצעים הסבירים לאבטחת המידע שיימסר לה על ידי המשתמש,
					עם זה הספק מבהיר כי לא יוכל לאבטח את המערכת מפני חדירות בלתי מורשות על
					ידי צד שלישי ואו מחדלים אשר אינם בשליטת ספק השירות בהתאם להסכם זה
					ובהתאם לכל דין.
				</li>
				<li>
					הספק רשאי לעשות שימוש בפרטי המשתמש לצורך פרטים סטטיסטיים ובכפוף
					להוראות בחוק.
				</li>
				<li>
					ספק השירות ומי קליניק שומרים לעצמם, כל אחד בנפרד או ביחד, את הזכות
					לשנות בכל עת את תנאי השירות, לרבות תעריפים או סגירתם ללא מתן הודעה
					מוקדמת מראש. למשתמש לא תהיה כל טענה ואו דרישה ואו תביעה כלפי הספק או
					מי קליניק בגין ביצוע האמור.
				</li>
				<li>
					תנאי הסכם זה אינם גורעים אלא מוסיפים על כל תנאי ואו הסרת ואו מגבלת
					אחריות, הקיימים לטובת הספק על פי כל הסכם אחר הקיים עימו ואו הקיים על
					פי כל דין.
				</li>
				<li>
					הלקוח יודע ומסכים כי הספק ו/או המפעיל הסלולרי רשאים לעיין ולפקח בכל
					עת, על סוגי, נושאי ותכני הודעות אותן יעביר הלקוח ו/או יבקש להעביר, וכן
					לאסור ו/או לפסול למשלוח סוגי ו/או נושאי הודעות מסוימים ו/או תכני
					הודעות ספציפיות, באופן מוחלט ו/או בהתניית תנאים למשלוח הודעות כאמור,
					לכלל המנויים ו/או לחלקם, והכל בכפוף לשיקול דעתם הבלעדי של הספק ו/או של
					המפעיל הסלולרי. למען הסר ספק מובהר כי אין בהוראה זו כדי להטיל על הספק
					ו/או על המפעיל הסלולרי כל אחריות או חבות, מכל מין וסוג, ביחס לתוכן
					ההודעות ו/או שליחתן, כי הן משמשות כרשת תקשורת להעברת ההודעות למנוי וכי
					האחריות הבלעדית בהקשר זה מוטלת על הלקוח.
				</li>
			</ol>
			<p><br /><br /></p>
			<p><strong>תשלום</strong></p>
			<p>
				השימוש במערכת המסרונים כרוך בתשלום חודשי קבוע כפי שייקבע מעת לעת עי
				מי-קליניק.&nbsp;
			</p>
			<p><strong>כללי</strong></p>
			<ol>
				<li>
					רישומי מי קליניק ו/או הספק ו/או של המפעיל הסלולרי בכל אופן ישמשו ראיה
					לכאורה לכל האמור בהם.
				</li>
				<li>
					המשתמש מאשר כי הספק רשאי בכל מקרה של פניה אליה בעיניינו של הלקוח למסור
					לפונה את פרטי ההתקשרות.
				</li>
			</ol>
			<p><strong>שיפוט</strong></p>
			<p>
				סמכות <strong>השיפוט </strong>הבלעדית לדיון בהוראות הסכם זה ו/או ביצוע
				חיוביהם של הצדדים על פיו נתונה לבתי המשפט המוסמכים באזור תל אביב יפו
				בלבד.
			</p>
		</div>

		<div class="modal-btns">
			<app-btn-ext
				text="accept_sms_terms"
				(clickEv)="acceptTerms()"
				[isSpin]="isSpin"
			/>
		</div>
	`,
})
export class TermsSmsComponent extends Modalable {
	isSpin: boolean = false

	async acceptTerms() {
		this.isSpin = true
		await this.apiService.post("update-sms-consent")
		this.isSpin = false
		this.onClose.emit(true)
		this.modalService.openToast("sms_confirmed")
	}
}
